// extracted by mini-css-extract-plugin
export default {"card-divider":"hZq+6Smm4Hu8nIeZsay7Eg=="};